import api from "@/services/api";
import apiEndpoints from "@/services/apiEndpoints";

const getDefaultState = () => {
  return {
    loginId: "",
    sessionId: "",
    userType: "",
    shopId: "",
    shopName: "",
  };
};

const state = getDefaultState();

const mutations = {
  // AUTH_REQUEST(state){
  //     state.status = 'loading';
  // },
  SAVE_USER_SESSION(state, payload) {
    state.loginId = payload.loginId;
    state.sessionId = payload.sessionId;
    state.userType = payload.userType;
    state.shopId = payload.shopId;
    state.shopName = payload.shopName;
  },
  DELETE_USER_SESSION(state) {
    state.loginId = "";
    state.sessionId = "";
    state.userType = "";
    state.shopId = "";
    state.shopName = "";
  },
};

const actions = {
  callDoLogin({ commit }, body) {
    return api.post(apiEndpoints.doLogin, body).then((r) => {
      let { loginId } = body;
      commit("SAVE_USER_SESSION", { ...r.data, loginId });
    });
  },
  callActionLogout({ commit }) {
    commit("DELETE_USER_SESSION");

    return api.post(apiEndpoints.doLogout, {});
  },
  someThing(x) {
    console.log(x);
  },
};
export default {
  state,
  mutations,
  actions,
};
